module.exports = __webpack_public_path__ + "img/8.bc4716b6.png";